import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import useOnMount from '../Utils/hooks/useOnMount';
import { PATH_NAME } from '../Routes/Pathname';
import { getAccessToken } from '../Utils/storage/user';
import PageWrapper from '../Layout/PageWrapper';
import CriticalGuard from './CriticalGuard';

export default function AuthGuard() {
	const navigate = useNavigate();
	
	const accessToken = getAccessToken();
	useOnMount(() => {
		if (!accessToken) {
			navigate(PATH_NAME.LOGIN);
		}
	});

	return (
		accessToken && (
			<>
			<CriticalGuard />
			<PageWrapper>
				<Outlet />
			</PageWrapper>
			</>
			
		)
	);
}
